import React, { useMemo } from 'react';
import LocalOpsSheet from './LocalOpsSheet';
import PostMediaCarousel from '../post/PostMediaCarousel';
import { normalizeMediaList } from '../../utils/postMediaUtils';

const getStatusLabel = (status) => {
  if (status === 'completed') return 'Completed';
  return 'Live now nearby';
};

const getSubtitle = (type, status) => {
  if (type !== 'task') return 'Your offering is now visible nearby.';
  if (status === 'completed') return 'Your task was completed nearby.';
  return 'Your task is ready for nearby helpers.';
};

const isCreatedTaskShare = (type, status) =>
  type === 'task' && status !== 'completed';

export default function LocalOpsShareSheet({
  open,
  type,
  item,
  status,
  onClose,
  onShare,
  onView,
}) {
  const mediaList = useMemo(
    () => (item ? normalizeMediaList(item) : []),
    [item],
  );
  const title = item?.title || item?.name || item?.meta?.title || 'LocalOps';
  const category =
    item?.category || item?.offeringType || item?.taskType || 'LocalOps';
  const statusLabel = getStatusLabel(status);
  const onePersonTaskShare = isCreatedTaskShare(type, status);
  const localActivityReward =
    type === 'task' && item?.localActivityReward?.awarded === true
      ? item.localActivityReward
      : null;
  const rewardStage = localActivityReward?.stage || null;
  const rewardTestId =
    rewardStage === 'completion'
      ? 'localops-completion-reward-surface'
      : 'localops-create-reward-surface';

  if (!open) return null;

  return (
    <LocalOpsSheet open={open} onClose={onClose} title="LocalOps Live">
      <div className="localops-success-card">
        <div className="localops-success-title">{statusLabel}</div>
        <div className="localops-success-subtitle">
          {onePersonTaskShare
            ? 'Know someone who could use this too? Send this task to one local person who might want help nearby or want to earn helping nearby.'
            : getSubtitle(type, status)}
        </div>
        <div className="localops-chip-group">
          <span className="localops-pill-chip">{category}</span>
          <span className="localops-pill-chip">{statusLabel}</span>
        </div>
        <div className="localops-preview-title">{title}</div>
        {localActivityReward ? (
          <div
            className="localops-success-reward"
            data-testid={rewardTestId}
          >
            <div className="localops-success-reward__eyebrow">
              {localActivityReward.title || 'Local spark earned'}
            </div>
            <div className="localops-success-reward__amount">
              +{Number(localActivityReward.amountJGK).toLocaleString('en-US')} JGK
            </div>
            <div className="localops-success-reward__copy">
              {localActivityReward.message ||
                'You earned JGK for starting local activity.'}
            </div>
            {localActivityReward.recognitionLabel ? (
              <div className="localops-success-reward__badge">
                {localActivityReward.recognitionLabel}
              </div>
            ) : null}
          </div>
        ) : null}
        {mediaList.length ? (
          <div className="localops-media-hero">
            <PostMediaCarousel
              item={item}
              autoPlay={false}
              enableZoom
              maxHeight="320px"
            />
          </div>
        ) : null}
        {type === 'offering' ? (
          <>
            <div className="localops-helper">
              You just made something locally available.
            </div>
            <div className="localops-helper">
              When it's found and used, value stays nearby.
            </div>
          </>
        ) : null}
        {status !== 'completed' ? (
          <>
            <div className="localops-success-actions">
              <button type="button" className="localops-btn" onClick={onShare}>
                {onePersonTaskShare ? 'Text it to someone' : 'Share & Earn JGK'}
              </button>
              <button
                type="button"
                className="localops-btn localops-btn--ghost"
                onClick={onView}
              >
                View on map
              </button>
            </div>
            <div className="localops-helper">
              {onePersonTaskShare
                ? "Shares use this task's rich link. No contacts are imported."
                : 'Earn JGK for sharing LocalOps.'}
            </div>
          </>
        ) : null}
      </div>
    </LocalOpsSheet>
  );
}
